export default __webpack_public_path__ + "static/media/logo.c4efe72a.png";